document.addEventListener("DOMContentLoaded", async function () {
  window.addEventListener("variant:changed", (e) => {
    const variant = e.detail.variant;

    const priceElement = document.querySelector("#ProductPrice");
    const comparePriceElement = document.querySelector("#ComparePrice");

    if (priceElement) {
      priceElement.innerHTML = wetheme.formatMoney(variant.price);
    }

    if (comparePriceElement && variant.compare_at_price && variant.compare_at_price > variant.price) {
      comparePriceElement.innerHTML = wetheme.formatMoney(variant.compare_at_price);
    }

    const variantOption1 = variant.option1 || "";

    const selectedVariants = jsProduct.variants.filter((variant) => {
      return variant.option1 === variantOption1;
    });

    if (selectedVariants.length > 0) {
      const secondarySwatches = document.querySelectorAll(
        "[data-option-index='1'] .variant-swatch"
      );
      if (secondarySwatches.length > 0) {
        secondarySwatches.forEach((swatch, index) => {
          const variant = selectedVariants[index];
          if (variant) {
            if (variant.available) {
              swatch.classList.remove("soldout");
              swatch.classList.add("available");
            } else {
              swatch.classList.remove("available");
              swatch.classList.add("soldout");
            }
          }
        });
      }
    }
  });
});
